/**
 * @memberof app
 * @ngdoc filter
 * @name toNumber
 */

(function() {
    'use strict';

    angular.module('app').filter('toNumber', function() {
        /**
         * @func toNumberFilter
         * @memberof toNumber
         * @param {String} num
         * @desc returns String representation of numeric as a Number, or null (if obj passed is null) or NaN (if parse error)
         */
        return function(num) {
            return parseInt(num);
        };
    });

}());